import styled from 'styled-components';

import { ANIM, COLORS, SPACE } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  ${(p) => (p.$disabled ? 'opacity: 0.55;' : '')}
`;

export const Label = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  // Off-scale on purpose: 6px keeps the affixes tight against the value they qualify, and the 14px
  // block padding is the control's established height; changing either would move every Field.
  gap: 6px;
  padding: 14px ${SPACE[16]};
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  /* Where the typing goes: the input drops the browser's outline, so its box says it has the focus. */
  &:focus-within {
    border-color: ${COLORS.accent};
  }
`;

export const Affix = styled(Text)`
  flex: 0 0 auto;
  color: ${COLORS.textMuted};
  font-size: 16px;
`;

/** The trailing slot for `suffixAction`: the affix's position, the control brings its own metrics. */
export const ActionSlot = styled.span`
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: ${COLORS.text};
  font-size: 16px;
  font-family: inherit;
  &::placeholder {
    color: ${COLORS.textFaint};
  }
`;
